export const langCounter = [
  { name: "O'zbekcha", label: 'nameUz' },
  { name: 'Русский', label: 'nameRu' },
  { name: 'English', label: 'nameEn' },
  { name: 'Turk', label: 'nameTr' },
  { name: 'Тоҷикӣ', label: 'nameTj' },
  { name: 'Кыргыз', label: 'nameKy' }
];
